﻿'use strict'

const SortFilterTable =
{
	asc: true,
	lastSortby: '',
	lastFilterby: '',
	lastFilter: '',

	init: target => {
		if (SortFilterTable.lastFilterby) {
			const lastFilterEl = target.querySelector(`input[ui-sortfilter="${SortFilterTable.lastFilterby}"]`)
			lastFilterEl.value = SortFilterTable.lastFilter
			SortFilterTable.filterTable(lastFilterEl)
		}

		const sortEl = target.querySelector(`th[ui-sortfilter="${SortFilterTable.lastSortby}"]`)
		SortFilterTable.asc = !SortFilterTable.asc
		SortFilterTable.sortTable(sortEl)

		target.addEventListener('click', e => {
			if (e.target.tagName == 'TH' && e.target.attributes['ui-sortfilter'])
				SortFilterTable.sortTable(e.target)
		})

		target.addEventListener('input', e => {
			if (e.target.tagName == 'INPUT' && e.target.attributes['ui-sortfilter'])
				SortFilterTable.filterTable(e.target)
		})
	},

	filterTable: element => {
		const filterby = element.attributes['ui-sortfilter'].value
		SortFilterTable.lastFilterby = filterby
		SortFilterTable.lastFilter = element.value
		const filterArr = SortFilterTable.getTRSortArray(element)
		if (!filterArr.length)
			return
		element.closest('tr').querySelectorAll(element.tagName)
			.forEach(el => {
				if (element != el)
					el.value = ''
			})

		filterArr.forEach(p => {
			if (p.keyStr.toLowerCase().indexOf(element.value.toLowerCase()) === -1)
				p.el.classList.add('hidden')
			else
				p.el.classList.remove('hidden')
		})
	},

	sortTable: element =>
	{
		if (element == null) return 0
		const sortby = element.attributes['ui-sortfilter'].value
		SortFilterTable.asc = SortFilterTable.lastSortby == sortby ? !SortFilterTable.asc : true
		SortFilterTable.lastSortby = sortby
		const tbody = element.closest('table').querySelector('tbody')
		const trArray = SortFilterTable.getTRSortArray(element)

		if (!trArray.length)
			return

		tbody.innerHTML = ''
		trArray.sort((a, b) => {
			if (a.keyStr < b.keyStr) {
				return SortFilterTable.asc ? -1 : 1;
			}
			if (a.keyStr > b.keyStr) {
				return SortFilterTable.asc ? 1 : -1;
			}
			return 0;
		}).forEach(p => tbody.appendChild(p.el))
	},

	getTRSortArray: element => {
		const column = Array.from(element.closest('tr').children).indexOf(element.tagName !== 'TH' ? element.closest('td') : element)
		return Array.from(element.closest('table').querySelector('tbody').querySelectorAll('tr[data-type]'))
			.map(el => {
				const td = el.getElementsByTagName('td')[column]
				if (!td)
					return
				const sortFilterAttr = td.attributes['ui-sortvalue']
				const keyStr = sortFilterAttr ? sortFilterAttr.value : td.innerText
				return {
					keyStr,
					el
				}
			})
	}
}

document.addEventListener('view.render', e => {
	const table = e.target.querySelector('table[ui-sortby]')
	if (table) {
		SortFilterTable.lastSortby = SortFilterTable.lastSortby || table.attributes['ui-sortby']?.value
		SortFilterTable.init(table)
	}
})

export default SortFilterTable
